import React from 'react'
import Page from '../../components/layouts/page'

import AssetValidatorsTable from './asset_validators_table'
import FieldValidatorsTable from './field_validators_table'
import { Navigate, Route, Routes } from 'react-router-dom'
import AirlineSpecificValidatorsTable from './airline_specific_validators_table'

const Validators = () => {
  return (
    <Page
      title='Validators'
      tabs={[
        { name: 'Field', to: 'field' },
        { name: 'Asset', to: 'asset' },
        { name: 'Airline Specific', to: 'airline-specific' },
      ]}
    >
      <Routes>
        <Route index element={<Navigate to='field' />} />
        <Route path='/field' element={<FieldValidatorsTable />} />
        <Route path='/asset' element={<AssetValidatorsTable />} />
        <Route path='/airline-specific' element={<AirlineSpecificValidatorsTable />} />
      </Routes>
    </Page>
  )
}

export default Validators
